export default __webpack_public_path__ + "static/black_7th_Background_wh-0ae8074e504b1527d633ab41a23f0432.jpg";